import { render, staticRenderFns } from "./customerDocuments.vue?vue&type=template&id=e30c14f8&"
import script from "./customerDocuments.vue?vue&type=script&lang=js&"
export * from "./customerDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports